<template>
  <div class="login-main">
    <div class="login-title">
      <img class="title-img" src="../assets/u38.png" />
      <span class="title-content">清单单价清册管理系统</span>
    </div>
    <div class="login-form">
      <div class="form-item-login">
        <div class="item-line"></div>
        <div style="margin-left: 4px; margin-right: 4px; flex-basis: 36px">
          登录
        </div>
        <div class="item-line"></div>
      </div>
      <div class="form-item">
        <el-input v-model="form.username" placeholder="账号"></el-input>
      </div>
      <div class="form-item">
        <el-input
          v-model="form.password"
          placeholder="密码"
          type="password"
          @keyup.enter.native="login"
        ></el-input>
      </div>
      <div class="form-item">
        <el-checkbox v-model="checked">下次自动登录</el-checkbox>
      </div>
      <div class="form-item">
        <el-button type="primary" style="width: 100%" @click="login"
          >登录</el-button
        >
      </div>
      <div class="form-item">
        <div style="color: red; text-align: center; font-size: 14px">
          {{ msg }}
        </div>
      </div>
    </div>
    <div class="record-name">
      <span>上海市房地产估价师协会</span>
    </div>
    <div class="record-name" style="margin-top: 10px;">
      <a href="https://beian.miit.gov.cn" target="_blank">沪ICP备05007719号</a>
    </div>
  </div>
</template>
<script>
import cookie from "../util/cookie.js";
import { userLogin } from "../api/";
import { storage } from "../util/";
export default {
  name: "Login",
  data() {
    return {
      input: "",
      msg: "",
      checked: true,
      form: {
        username: "",
        password: "",
      },
    };
  },
  computed: {},
  created() {
    let autoLogin = cookie.getItem("autoLogin");
    if (autoLogin === "true") {
      this.$router.push({ name: "inventoryList" });
    }
  },
  methods: {
    async login() {
      const res = await userLogin(this, this.form);
      if (res && Number.parseInt(res.ret) === 1) {
        storage("token", res.data.token);
        storage("channel", res.data.channel);
        storage("name", res.data.name);
        // storage('auto', this.checked)
        cookie.setItem("autoLogin", this.checked, 365 * 24 * 60 * 60);
        this.$oneitfarm.setToken(res.data.token);
        this.$oneitfarm.setChannel(res.data.channel);
        let result = await this.$http.post(
          this.$oneitfarm.getApiBaseUrl() + "index.php/User/getUserPermission",
          {
            accountId: res.data.account_id,
          }
        );
        if (Number.parseInt(result.data.ret) === 1) {
          let aclObjs = result.data.data;
          let acls = aclObjs.map((aclObj) => {
            return aclObj.resourceKey;
          });
          storage("resourceKey", acls);
        }
        this.$router.push({ name: "inventoryList" });
      } else {
        this.msg = res.msg;
      }
    },
  },
};
</script>

<style scoped>
::-webkit-scrollbar {
  width: 0px;
}

.login-main {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  background-color: rgba(242, 242, 242, 1);
}
.login-title {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.title-img {
  width: 52px;
  height: 50px;
}
.title-content {
  font-family: "PingFangSC-Regular", "PingFang SC";
  font-weight: 400;
  font-style: normal;
  font-size: 28px;
  color: #434343;
  margin-left: 12px;
}
.login-form {
  margin-top: 32px;
  width: 550px;
  height: 394px;
  background-color: rgba(255, 255, 255, 1);
  box-sizing: border-box;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(148, 148, 148, 1);
  box-shadow: 2px 2px 2px rgba(188, 188, 188, 0.647058823529412);
  font-family: "微软雅黑";
}
.form-item {
  margin-left: 90px;
  margin-right: 90px;
  margin-bottom: 8px;
  margin-top: 24px;
}
.form-item-login {
  margin-top: 40px;
  margin-left: 90px;
  margin-right: 90px;
  margin-bottom: 8px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.item-line {
  flex-basis: 50%;
  border-bottom: 1px solid #dcdfe6;
}
.record-name {
  margin-top: 48px;
  font-family: "PingFangSC-Regular", "PingFang SC";
  font-weight: 400;
  font-style: normal;
  font-size: 14px;
  color: #bcbcbc;
  text-align: center;
}
</style>
